(function () {

    "use strict";

    function basicListService($rootScope, $resource, $filter, $mdToast, $mdDialog, $translate, $q, $state, basicService) {

        var vm = this;

        vm.instantiate = function (list) {
            var paginationFactory = {};

            basicService.instantiate(list);
            list.filter = {};
            list.service = {};
            list.items = [];
            list.filter.pageSize = 100;
            list.filter.pageIndex = 0;

            list.pageChanged = function (data) {
                list.filter.pageIndex = data.paginaActiva - 1;
                list.getItemsPaged();
            };

            list.pagination = paginationFactory;//.New();
            list.pagination.pageChanged = list.pageChanged;

            list.getItemsPaged = function (filtro) {

                list.filter.filtro = filtro;
                for (var propertyName in list.filter) {
                    if (list.filter[propertyName] === null || list.filter[propertyName] === undefined) {
                        delete list.filter[propertyName];
                    }
                }
                list.service.getItems(list.filter).then(function (data) {
                    list.items = data;
                });
            };

            list.selectAll = function (value) {
                list.items.forEach(function (item) {
                    item.seleccionado = value;
                });
            };

            list.selectedChange = function () {
                var selecteds = ($filter('filter')(list.items, { seleccionado: true })).length;
                list.allSlected = selecteds === list.items.length && selecteds > 1;
            };

            list.deleteItems = function (items) {
                list.service.delete(items).then(function () {
                    list.getItemsPaged();
                });
            };

            list.editModalItem = function (item) {

                if (item) {
                    list.idEditItem = item.id;
                }
                else {
                    list.idEditItem = -1;
                    item = {};
                }

                if (list.stateForEdit) {
                    $state.go(list.stateForEdit, { idEntity: item.id });
                }

                if (list.templateModalEdit) {
                    $mdDialog.show({
                        controller: $rootScope.$new(true),
                        contentElement: list.templateModalEdit,
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: true
                    }).then(function (item) {
                        list.service.save(item).then(function () {
                            list.getItemsPaged();
                        });
                        list.idEditItem = null;
                    }, function () {
                        list.idEditItem = null;
                    });
                }
            };

            list.setOrder = function (column) {
                list.orderColumns = list.orderColumns.map(function (item) {
                    item.sort = item.name === column.name ? item.sort === "asc" ? "desc" : "asc" : "";
                    return item;
                });
            };

            list.setAllowedSortColumns = function (columNames) {

                list.orderColumns = columNames.map(function (item) {
                    return { name: item, sort: "" };
                });
            };

            list.appliySort = function () {
                list.showSort = false;
                angular.forEach(list.orderColumns, function (item) {
                    if (item.sort !== "") {
                        list.filter.sortOrder = item.sort;
                        list.filter.sortColumn = item.name;
                        list.filter.pageIndex = 0;
                        list.getItemsPaged();
                    }
                });
            };

            list.appliyFilter = function () {

                list.showFilter = false;
                list.filter.pageIndex = 0;
                list.getItemsPaged();
            };

            list.clearFilter = function () {

                list.showFilter = false;
                var newFilter = {};
                newFilter.sortOrder = list.filter.sortOrder;
                newFilter.sortColumn = list.filter.sortColumn;
                newFilter.pageSize = list.filter.pageSize;
                newFilter.pageIndex = 0;
                list.filter = newFilter;
                list.getItemsPaged();
            };

            list.goHome = function () {
                $state.go("home");
            };

            return list;
        };

    }

    basicListService.$inject = ["$rootScope", "$resource", "$filter", "$mdToast", "$mdDialog", "$translate", "$q", "$state", "sphforms.basicService"];

    angular.module("sphforms.main").service("sphforms.basicListService", basicListService);

})();
